import { createPortal } from "react-dom";

export function SuccessMessage({
  message,
  open,
}: {
  open: boolean;
  message: string;
}) {
  return open
    ? createPortal(
        <div
          className={
            "fixed bottom-5 flex items-center justify-center left-0 right-0"
          }
        >
          <div className={"bg-green-300 text-slate-900 rounded-lg p-2"}>
            <p>{message}</p>
          </div>
        </div>,
        document.body,
      )
    : null;
}
